import ConfirmCaptcha from './ConfirmCaptcha';

export default ConfirmCaptcha;
